import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FiSearch } from 'react-icons/fi';
import GlobalSearchModal from './GlobalSearchModal';

/**
 * HeaderSearch — nút search cạnh breadcrumb (dáng "pill" như /drives/list).
 * Click (hoặc ⌘/Ctrl+K) sẽ mở GlobalSearchModal (command palette).
 * Toàn bộ logic search nằm ở GlobalSearchModal + searchProvider (file riêng).
 */
const isMac =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

const HeaderSearch = ({ className, placeholder = 'Tìm kiếm...' }) => {
  const [show, setShow] = useState(false);

  // Phím tắt ⌘K / Ctrl+K để mở
  useEffect(() => {
    const onKey = e => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setShow(true);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      {/* Phone: biểu tượng tròn 40px, đứng cùng hàng với các icon top-nav khác.
          Pill rộng 260–280px nên trước đây cả HeaderSearch bị ẩn dưới `md`, và
          vì ⌘K không tồn tại trên điện thoại, global search thành ra không có
          đường nào mở — mất hẳn tính năng chứ không chỉ khó dùng. */}
      <button
        type="button"
        onClick={() => setShow(true)}
        aria-label="Open search"
        className={classNames(
          'md:tw-hidden tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 ' +
            'tw-rounded-full tw-border-0 tw-bg-transparent tw-cursor-pointer ' +
            'tw-text-slate-500 hover:tw-text-slate-800 hover:tw-bg-slate-100 tw-transition-colors',
          className
        )}
      >
        <FiSearch size={18} aria-hidden />
      </button>

      <button
        type="button"
        onClick={() => setShow(true)}
        aria-label="Open search"
        className={classNames(
          // Pill giống ô input cũ nhưng là button mở modal
          'tw-hidden md:tw-flex tw-items-center tw-gap-2 tw-h-9 tw-w-[260px] lg:tw-w-[280px] ' +
            'tw-pl-3 tw-pr-2 tw-bg-slate-50 tw-border tw-border-slate-200 ' +
            'tw-rounded-[10px] tw-cursor-pointer tw-transition-colors ' +
            'hover:tw-border-primary-400 hover:tw-bg-white',
          className
        )}
      >
        <FiSearch className="tw-text-slate-400 tw-flex-shrink-0" size={13} aria-hidden />
        <span className="tw-flex-1 tw-text-left tw-truncate tw-text-[12px] tw-text-slate-400">
          {placeholder}
        </span>
        <kbd className="tw-flex-shrink-0 tw-text-[10px] tw-font-sans tw-font-semibold tw-text-slate-400 tw-bg-white tw-border tw-border-slate-200 tw-rounded-sm tw-px-1.5 tw-py-0.5 tw-leading-none">
          {isMac ? '⌘K' : 'Ctrl K'}
        </kbd>
      </button>

      <GlobalSearchModal show={show} onHide={() => setShow(false)} />
    </>
  );
};

HeaderSearch.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string
};

export default HeaderSearch;
